import React from 'react';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';
import { __ } from '../../Lang.js'; // Add translation function import

const VideoControlsPanel = ({
  isPlaylistContext = false,
  activeTab,
  setActiveTab,
  autoplay,
  repeat,
  shuffle,
  setAutoplay,
  setShuffle,
  setRepeat,
   isMobile,
   context = {}
}) => {
  const isCollectionType = context.type === 'collection' || context.type === 'audiobook';
  const leftTabLabel = isCollectionType ? __('COLLECTION') : __('Related Content');
  const leftTabValue = isCollectionType ? 'collection' : 'related';

  return (
    <div className="video-controls-bar">
      <div className="video-controls-tabs">
        {!isPlaylistContext && ( // Hide left tab if in playlist context
          <Button
            onClick={() => setActiveTab(leftTabValue)}
            variant="text"
            sx={{
              padding: { xs: '0.25rem 0.75rem', sm: '0.4rem 0.75rem', md: '20px 30px' },
              color: activeTab === leftTabValue ? '#fff' : '#999',
              fontWeight: activeTab === leftTabValue ? 'bold' : 'normal',
              borderBottom: activeTab === leftTabValue ? '3px solid #fff' : '3px solid transparent',
              borderRadius: 0,
              textTransform: 'uppercase',
              fontSize: { xs: '0.75rem', sm: '0.85rem', md: 'inherit' },
              '&:hover': { backgroundColor: 'transparent', color: '#fff' },
            }}
          >
            {leftTabLabel}
          </Button>
        )}
        <Button
          onClick={() => setActiveTab('recommended')}
          variant="text"
          sx={{
            padding: { xs: '0.25rem 0.75rem', sm: '0.4rem 0.75rem', md: '20px 30px' },
            color: activeTab === 'recommended' ? '#fff' : '#999',
            fontWeight: activeTab === 'recommended' ? 'bold' : 'normal',
            borderBottom: activeTab === 'recommended' ? '3px solid #fff' : '3px solid transparent',
            borderRadius: 0,
            textTransform: 'uppercase',
            fontSize: { xs: '0.75rem', sm: '0.85rem', md: 'inherit' },
            '&:hover': { backgroundColor: 'transparent', color: '#fff' },
          }}
        >
          {__('Recommended Content')}
        </Button>
      </div>

{!isMobile && (
  <div className="video-controls-toggles">
    <FormControlLabel
      control={<Switch size="small" checked={autoplay} onChange={(e) => setAutoplay(e.target.checked)} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' }, '& .MuiSwitch-track': { backgroundColor: '#ccc' } }} />}
      label={__('AUTO PLAY')}
      sx={{ '& .MuiFormControlLabel-label': { color: '#999', fontSize: '0.75rem', whiteSpace: 'nowrap' }, mr: 2 }}
    />

    <FormControlLabel
      control={<Switch size="small" checked={repeat} onChange={(e) => setRepeat(e.target.checked)} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' }, '& .MuiSwitch-track': { backgroundColor: '#ccc' } }} />}
      label={__('REPEAT')}
      sx={{ '& .MuiFormControlLabel-label': { color: '#999', fontSize: '0.75rem', whiteSpace: 'nowrap' }, mr: 2 }}
    />

    <FormControlLabel
      control={<Switch size="small" checked={shuffle} onChange={(e) => {
        const checked = e.target.checked;
        setShuffle(checked);
        if (checked && !autoplay) {
          setAutoplay(true);
        }
      }} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#4caf50' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#4caf50' }, '& .MuiSwitch-track': { backgroundColor: '#ccc' } }} />}
      label={__('SHUFFLE')}
      sx={{ '& .MuiFormControlLabel-label': { color: '#999', fontSize: '0.75rem', whiteSpace: 'nowrap' }, mr: 0 }}
    />
  </div>
)}


    </div>
  );
};

VideoControlsPanel.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  autoplay: PropTypes.bool.isRequired,
  shuffle: PropTypes.bool.isRequired,
  repeat: PropTypes.bool.isRequired,
  setAutoplay: PropTypes.func.isRequired,
  setShuffle: PropTypes.func.isRequired,
  setRepeat: PropTypes.func.isRequired,
  context: PropTypes.object
};

export default VideoControlsPanel;